/* Complete the Fit — track pants bundle builder
   - Adds pants (from main product form) + a $50 hidden companion = $149, then -> /checkout
   - Click listeners only (never a form submit) so udesly-shopify.min.js can't intercept
   - Self-contained: shares no listeners/vars with the main ATC button
*/
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    var section = document.getElementById("complete-the-fit");
    if (!section) return;

    var configEl = section.querySelector("[data-ctf-config]");
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error("CTF: bad config JSON", e);
      return;
    }

    var cards = Array.prototype.slice.call(section.querySelectorAll(".ctf-card"));
    var sizeWrap = section.querySelector(".ctf-size");
    var sizeOptions = section.querySelector(".ctf-size-options");
    var addBtn = section.querySelector(".ctf-add");
    var note = section.querySelector(".ctf-note");

    var selectedKey = null;
    var selectedVariantId = null;

    // ---- main product form (pants). The bundle section has no form, so this
    // resolves to the real ATC form even with the selector scoped to document.
    function pantsForm() {
      return document.querySelector('form[action="/cart/add"]');
    }
    function pantsVariantId() {
      var f = pantsForm();
      var input = f ? f.querySelector('input[name="id"]') : null;
      return input && input.value ? input.value : null;
    }
    // human-readable pants size for the note, best-effort via window.product
    function pantsSizeLabel() {
      var id = pantsVariantId();
      if (!id || !window.product || !window.product.variants) return null;
      var v = window.product.variants.find(function (x) { return String(x.id) === String(id); });
      return v ? (v.option1 || v.title) : null;
    }
    function refreshNote() {
      var size = pantsSizeLabel();
      note.textContent = size
        ? "Pants size " + size + " — taken from your selection above."
        : "Pants size is taken from your selection at the top of the page.";
    }

    function setAddState() {
      var ready = selectedKey && selectedVariantId;
      addBtn.disabled = !ready;
      if (!selectedKey) { addBtn.textContent = "Select an item"; return; }
      var opt = config.options[selectedKey];
      if (!opt.oneSize && !selectedVariantId) { addBtn.textContent = "Select a size"; return; }
      addBtn.textContent = "Add Bundle to Cart — " + config.bundlePrice;
    }

    function renderSizes(key) {
      var opt = config.options[key];
      sizeOptions.innerHTML = "";
      selectedVariantId = null;

      if (opt.oneSize) {
        // hat: no selector, auto-pick the single variant if available
        var only = opt.sizes[0];
        sizeWrap.hidden = true;
        selectedVariantId = only && only.available ? only.variantId : null;
        setAddState();
        return;
      }

      sizeWrap.hidden = false;
      opt.sizes.forEach(function (s) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "ctf-size-btn";
        b.textContent = s.size;
        if (!s.available) {
          b.disabled = true;
          b.title = "Sold out";
        } else {
          b.addEventListener("click", function () {
            sizeOptions.querySelectorAll(".ctf-size-btn").forEach(function (x) { x.classList.remove("is-selected"); });
            b.classList.add("is-selected");
            selectedVariantId = s.variantId;
            setAddState();
          });
        }
        sizeOptions.appendChild(b);
      });
      setAddState();
    }

    cards.forEach(function (card) {
      if (card.disabled) return;
      card.addEventListener("click", function () {
        var key = card.getAttribute("data-key");
        cards.forEach(function (c) { c.classList.remove("is-selected"); });
        card.classList.add("is-selected");
        selectedKey = key;
        renderSizes(key);
        refreshNote();
      });
    });

    // keep the note in sync if the customer changes pants size after selecting
    var pf = pantsForm();
    if (pf) {
      pf.addEventListener("change", refreshNote);
      pf.addEventListener("click", function () { setTimeout(refreshNote, 0); });
    }

    addBtn.addEventListener("click", function () {
      if (addBtn.disabled) return;
      var pantsId = pantsVariantId();
      if (!pantsId) { showError("Please choose your pants size at the top of the page first."); return; }
      if (!selectedVariantId) { showError("Please choose a size for your bundle item."); return; }

      addBtn.disabled = true;
      var prev = addBtn.textContent;
      addBtn.textContent = "Adding...";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [
          { id: pantsId, quantity: 1 },
          { id: selectedVariantId, quantity: 1 }
        ] })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
        .then(function (res) {
          if (!res.ok || res.status === 422) {
            throw new Error((res.data && res.data.description) || "One of these items just sold out.");
          }
          // straight to checkout — avoids the cart drawer / Selleasy upsell JS errors
          window.location.href = "/checkout";
        })
        .catch(function (err) {
          console.error("CTF add error:", err);
          showError(err.message || "Sorry, that didn't work. Please try again.");
          addBtn.disabled = false;
          addBtn.textContent = prev;
        });
    });

    function showError(msg) {
      var existing = section.querySelector(".ctf-error");
      if (existing) existing.remove();
      var p = document.createElement("p");
      p.className = "ctf-error";
      p.setAttribute("role", "alert");
      p.style.cssText = "color:#d20404;font-size:13px;text-align:center;margin:10px 0 0;";
      p.textContent = msg;
      addBtn.insertAdjacentElement("afterend", p);
    }

    // init
    setAddState();
    refreshNote();
  });
})();
